import script from "./PersonCard.vue?vue&type=script&setup=true&lang=js"
export * from "./PersonCard.vue?vue&type=script&setup=true&lang=js"

import "./PersonCard.vue?vue&type=style&index=0&id=228464f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-228464f6"]])

export default __exports__